// extracted by mini-css-extract-plugin
export default {"wrapper":"GQ-z","availablePromoMessagesLabel":"HQ-z","promoMessageList":"IQ-z","promoMessage":"JQ-z","appliedPromoMessage":"KQ-z","promoMessageAmount":"LQ-z"};